


















































import { Component, Vue } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChartLine, faLock } from "@fortawesome/free-solid-svg-icons";

library.add(faChartLine, faLock);

import Footer from "@/components/Footer.vue";
import ModalBase from "@/components/modal/ModalBase.vue";
import WalletConnector from "@/components/wallet/WalletConnector.vue";

import MyStaking from "@/components/stake/MyStaking.vue";
import StakeNavbar from "@/components/stake/StakeNavbar.vue";
import StakeStats from "@/components/stake/StakeStats.vue";

import { reserveTokenAddress } from "@/api/contracts/Contract";
import { StakingManager } from "@/api/contracts/StakingManager";
import { ERC20 } from "@/api/contracts/ERC20";

import TSXApi from "@/api/tsx";
import EventBus, { ACTIONS } from "@/event-bus";

@Component({
  components: {
    FontAwesomeIcon,
    Footer,
    ModalBase,
    WalletConnector,
    MyStaking,
    StakeNavbar,
    StakeStats,
  },
})
export default class Stake extends Vue {
  private showWalletModal = false;

  private stakingManager: any = new StakingManager();
  private reserveToken: any = new ERC20(reserveTokenAddress, "ether");

  private tokenPrice = 0;
  private tokenPriceVariation = 0;
  private tokenCirculatingsupply = 0;

  private totalStaked = 0;
  private dailyRewards = 0;

  private balanceUpdateTimer: any = null;

  private closeWalletModal() {
    this.showWalletModal = false;
  }

  private beforeDestroy() {
    clearTimeout(this.balanceUpdateTimer);

    this.stakingManager = null;
    this.reserveToken = null;
  }

  private async mounted() {
    this.reserveToken.initReadOnly();
    this.stakingManager.initReadOnly();

    const updateInfo = async () => {
      const response = await TSXApi.tokenValues();
      const tInfo = response[0];

      this.tokenPrice = tInfo.current_price;
      this.tokenPriceVariation = tInfo.price_change_percentage_24h;
      this.tokenCirculatingsupply = tInfo.circulating_supply;

      [this.totalStaked, this.dailyRewards] = await Promise.all([
        this.getTotalStaked(),
        this.calcDailyRewards(),
      ]);

      // sync info timer
      clearTimeout(this.balanceUpdateTimer);
      this.balanceUpdateTimer = setTimeout(updateInfo, 60000);
    };

    updateInfo();

    EventBus.$on(ACTIONS.ETH_WALLET_TX, async () => {
      updateInfo(); // force update also when tx is made.
    });

    EventBus.$on(ACTIONS.ETH_UPDATE_ACCOUNTS, async () => {
      this.closeWalletModal();
    });
  }

  private async getTotalStaked() {
    const balance = await this.reserveToken.balanceOf(
      this.stakingManager.getAddress()
    );
    return Number(balance); // TODO: should correctly use BN / strings.
  }

  private async calcDailyRewards() {
    const claimablePerSecond = await this.stakingManager.claimablePerSecond();
    return claimablePerSecond * 60 * 60 * 24;
  }
}
